const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * Parse a pasted string of emails separated by commas, semicolons, or newlines.
 * Deduplicates (case-insensitive) and validates format.
 */
export const parseBulkEmails = (input) => {
  if (!input || typeof input !== 'string') {
    return { validFormat: [], invalidFormat: [], totalParsed: 0 };
  }

  const tokens = input
    .split(/[,;\n]+/)
    .map((t) => t.trim())
    .filter(Boolean);

  const seen = new Set();
  const validFormat = [];
  const invalidFormat = [];

  tokens.forEach((token) => {
    const normalized = token.toLowerCase();
    if (seen.has(normalized)) {
      return;
    }
    seen.add(normalized);

    if (EMAIL_REGEX.test(token)) {
      validFormat.push(token);
    } else {
      invalidFormat.push(token);
    }
  });

  return {
    validFormat,
    invalidFormat,
    totalParsed: tokens.length,
  };
};

export const EMAIL_FORMAT_REGEX = EMAIL_REGEX;
